import { testimonials } from '@/mocks/site';

export default function Testimonials() {
  return (
    <section className="w-full border-y border-background-200 bg-secondary-950 px-4 py-12 md:px-8 md:py-16">
      <div className="mb-8 text-center">
        <span className="text-sm font-bold text-accent-400">瓜友怎么说</span>
        <h2 className="mt-2 font-heading text-2xl text-white md:text-3xl">每天准点来蹲更新的人</h2>
      </div>
      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {testimonials.map((item) => (
          <figure key={item.name} className="flex flex-col rounded-lg bg-secondary-900 p-6">
            <i className="ri-double-quotes-l text-3xl text-accent-400" aria-hidden="true"></i>
            <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-secondary-100">
              {item.text}
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-3 border-t border-secondary-700 pt-4">
              <span className="flex h-11 w-11 overflow-hidden rounded-full bg-secondary-800">
                <img src={item.avatar} alt={`${item.name} 的头像插画`} title={item.name} className="h-full w-full object-top" />
              </span>
              <span className="flex flex-col">
                <span className="text-sm font-bold text-white">{item.name}</span>
                <span className="text-xs text-secondary-300">{item.role}</span>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}